<template>
  <div>
    <el-form :inline="true" :model="query" @keyup.enter.native="load">
      <el-form-item label="会计年度">
        <el-input v-model="query.year" placeholder="如 2026" size="small" clearable style="width:120px" />
      </el-form-item>
      <el-form-item label="结账状态">
        <el-select v-model="query.periodStatus" placeholder="全部" size="small" clearable>
          <el-option label="未结账" value="0" />
          <el-option label="已结账" value="1" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('finance:period:list')" type="primary" size="small" @click="load">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('finance:period:save')" type="primary" size="small" @click="open">新增年度</el-button>
      </el-form-item>
    </el-form>

    <div class="period-hint">请按期号顺序结账；结账前须完成本期凭证记账及损益结转。</div>

    <el-table :data="shown" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="year" label="会计年度" width="100" align="center" />
      <el-table-column prop="periodNo" label="期号" width="70" align="center" />
      <el-table-column prop="startDate" label="开始日期" width="120" align="center" />
      <el-table-column prop="endDate" label="结束日期" width="120" align="center" />
      <el-table-column prop="periodStatus" label="结账状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.periodStatus === '1'" type="success" size="small">已结账</el-tag>
          <el-tag v-else type="info" size="small">未结账</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" align="center">
        <template slot-scope="scope">
          <el-button v-if="isAuth('finance:period:close') && scope.row.periodStatus !== '1'" type="text" size="small" @click="closeLine(scope.row)">结账</el-button>
          <el-button v-if="isAuth('finance:period:close') && scope.row.periodStatus === '1'" type="text" size="small" @click="uncloseLine(scope.row)">反结账</el-button>
        </template>
      </el-table-column>
    </el-table>

    <period-add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="load" />
  </div>
</template>

<script>
import PeriodAddOrUpdate from './period-add-or-update'
import request from '../../api/request'
import auth from './financeAuth'

export default {
  mixins: [auth],
  components: { PeriodAddOrUpdate },
  data() {
    return {
      query: { year: '', periodStatus: '' },
      list: [],
      addOrUpdateVisible: false
    }
  },
  computed: {
    shown() {
      return this.list.filter(row => {
        if (this.query.year && String(row.year) !== String(this.query.year)) return false
        if (this.query.periodStatus && String(row.periodStatus) !== this.query.periodStatus) return false
        return true
      })
    }
  },
  created() { this.load() },
  methods: {
    load() {
      this.loading = true
      request.get('/finance/period/list').then(res => { this.list = res.data || [] }).finally(() => { this.loading = false })
    },
    open() {
      this.addOrUpdateVisible = true
      this.$nextTick(() => this.$refs.addOrUpdate && this.$refs.addOrUpdate.init())
    },
    closeLine(row) {
      this.$confirm(`确认结账 ${row.year} 年第 ${row.periodNo} 期？`, '提示', { type: 'warning' }).then(() => {
        request.post('/finance/period/close', { id: row.financePeriodLineId }).then(() => {
          this.$message.success('结账成功')
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    uncloseLine(row) {
      this.$confirm(`确认反结账 ${row.year} 年第 ${row.periodNo} 期？`, '提示', { type: 'warning' }).then(() => {
        request.post('/finance/period/unclose', { id: row.financePeriodLineId }).then(() => {
          this.$message.success('反结账成功')
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.period-hint { margin: -4px 0 12px; color: #909399; font-size: 12px; }
</style>
